import growUp from './assets/grow-up.png';
import toggle from './assets/toggle.png';
import humanEye from './assets/human-eye.png';
import { NBSP } from 'shared/constants/symbols';

export const PROMO_FEATURES = [
  {
    id: 1,
    title: 'Получите больше уникальных просмотров',
    description: 'Чем выше ставка и лимит, тем больше эффективности вы получите',
    image: growUp,
  },
  {
    id: 2,
    title: 'Опередите похожие объявления',
    description: 'Информация о разбросе ставок — ваше конкурентное преимущество',
    image: toggle,
  },
  {
    id: 3,
    title: `Контролируйте расходы на${NBSP}продвижение`,
    description: `Списание средств происходит за${NBSP}уникальные просмотры ваших объявлений`,
    image: humanEye,
  },
];
